
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 24a.743.743 0 01-.53-.22c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53l3.391-3.391-.105-.105a2.25 2.25 0 01-.161-3.002l8.66-10.441a6.001 6.001 0 011.258-3.458l-.566-.566c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53a.749.749 0 011.06 0l.566.566A5.992 5.992 0 0118 0c3.308 0 6 2.692 6 6a5.987 5.987 0 01-1.263 3.676l.566.566c.142.141.22.33.22.53s-.078.389-.22.53a.749.749 0 01-1.06 0l-.566-.566a5.999 5.999 0 01-3.458 1.258L7.79 20.648a2.27 2.27 0 01-1.421.505 2.232 2.232 0 01-1.587-.657l-.109-.108L1.28 23.78a.743.743 0 01-.53.22zm3.756-6.828a.744.744 0 00.06.991l1.275 1.271a.745.745 0 001.001.052l9.358-7.765a6.032 6.032 0 01-3.92-3.92l-7.774 9.371zm9.83-13.775A4.484 4.484 0 0013.5 6c0 2.481 2.019 4.5 4.5 4.5.933 0 1.844-.294 2.604-.836l-6.268-6.267zm7.328 5.206c.542-.759.836-1.67.836-2.603 0-2.481-2.019-4.5-4.5-4.5-.933 0-1.844.294-2.604.836l6.268 6.267z"}}),_c('path',{attrs:{"d":"M12.335 12.958a1.12 1.12 0 01-1.125-1.123 1.12 1.12 0 011.126-1.124c.299 0 .58.115.791.324.441.441.442 1.155.004 1.594a1.119 1.119 0 01-.796.329z"}})])
          )
        }
      }
    